module.exports = __webpack_public_path__ + "img/icon_map_511.97783e21.svg";